import api from "./apiURL";

export async function getSupport() {
  try {
    const response = await api.get(`/api/v1/support/getAll`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function updateSupport(data) {
  try {
    const response = await api.put(`/api/v1/support/message`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function updateStatus(data) {
  try {
    const response = await api.put(`/api/v1/support/action`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
export async function updateSeen(data) {
  try {
    const response = await api.put(`/api/v1/support/message/seen`, data);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
